import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import {SharedServiceService} from 'app/services/shared-service.service';

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit, OnChanges {
  @Input() hasError = false;
  invalid = false;
  @Input() readonly = false;
  @Input() amount = '';
  @Input() minPrice = 0;
  @Input() maxPrice = 99999999999;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Input() priceTitle = 'مبلغ';
  @Input() optional = false;
  constructor(private sharedService: SharedServiceService) { }
  ngOnInit(): void {
    this.amount = this.amount.toString();
    if (this.amount && this.amount.length > 0) {
      this.pricePattern('');
    }
  }
  ngOnChanges() {
    if (this.amount && this.amount.length > 0) {
      this.pricePattern('');
    }
  }
  sendParentNotification(event) {
    const temp = this.amount.split(',').join('');
    if (temp === '') {
      this.hasError = true;
    } else {
      this.hasError = false;
      const value = Number(temp);
      this.notifyParent.emit(this.sharedService.convertToEnglishNumber(temp));
    }
  }
  pricePattern(event) {
    if (event.key === 'Backspace') {
      if (this.amount === '') {
        this.hasError = true;
        this.notifyParent.emit('');
      }
    }
    let temp = this.sharedService.convertToEnglishNumber(this.amount);
    temp = temp.split(',').join('');
    this.notifyParent.emit(temp);

    if (temp.length > 0) {
      temp =  temp.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      this.hasError = false;
    }
    this.amount = temp;
  }
}
